import React from 'react';
import PropTypes from 'prop-types';
import { ChangeFirstLetterCapital, getFileIcon } from '../../lib/common';

const CommentsPopup = ({ commentsData, commentsRef, myTicketsData, handleClosePopup }) => {
  return (
    <section className="cs_modal csslbusiness_pop">
      <div
        id={commentsData?.length > 3 ? `comments-div` : ''}
        className="jsx-2666181935 cs_modal_content cs_modal_animation cs_modal_up"
        ref={commentsRef}
      >
        <div className="jsx-2666181935 cs_modal_body">
          <div className="pt-20 pl-20 pr-20 pb-20">
            <div className="font13 fw500 color111 pb-15 popup-heading-div">
              Comment History
              <div
                className="modal_close csicon"
                onClick={() => {
                  const commentsPopup = 1;
                  handleClosePopup(commentsPopup);
                }}
                aria-label="Close Modal"
                type="button"
                tabIndex={0}
                role="button"
                onKeyDown={() => {}}
              />
            </div>
            <div className={commentsData?.length > 3 ? 'comments_content_box' : ''}>
              {commentsData &&
                commentsData.map((each, idx) => (
                  <div key={idx} style={{ paddingBottom: '32px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', paddingBottom: '12px' }}>
                      <div className="font14 fw500 color111 pb-5" style={{ display: 'flex' }}>
                        <img
                          src={
                            each?.type === 'disposition_comment'
                              ? 'https://images.jdmagicbox.com/standard/cs_module/910cd10f9bc8e86728b14dffb2454377.jpg'
                              : 'https://images.jdmagicbox.com/standard/cs_module/def2ceaabdbdee1a08d469d9fd45b990.jpg'
                          }
                          alt="mySvgImage"
                          style={{ height: '21px', width: '21px', marginRight: '7px' }}
                        />
                        <div>
                          {each?.type === 'disposition_comment' && each?.agentName && each?.agentId
                            ? each.agentName.toLowerCase().includes('ai')
                              ? ''
                              : each.agentName
                            : myTicketsData && myTicketsData.length > 0
                              ? myTicketsData[0]?.nm
                              : ''}
                          <div className="font12 fw400 color777 pb-5">
                            {each?.type === 'disposition_comment' ? 'Agent' : 'Business'}
                          </div>
                        </div>
                      </div>
                      <div style={{ marginRight: '6px' }}>
                        <div className="font12 fw400 color777 pb-2">{each.updatedAt.split(',')[0]}</div>
                        <div className="font12 fw400 color777 pb-5">{each.updatedAt.split(',')[1]?.trim()}</div>
                      </div>
                    </div>
                    <div className="font14 fw500 color111 pb-5">{ChangeFirstLetterCapital(each.comment)}</div>
                    {Array.isArray(each?.document) && each.document.length > 0 && (
                      <div
                        style={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          gap: '8px',
                          marginTop: '8px',
                        }}
                      >
                        {each.document.map((doc, dIdx) => (
                          <a
                            key={dIdx}
                            href={doc.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            download
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px',
                              padding: '6px 10px',
                              border: '1px solid #e6e6e6',
                              borderRadius: '6px',
                              backgroundColor: '#fff',
                              textDecoration: 'none',
                              maxWidth: '180px',
                            }}
                          >
                            <img
                              src={getFileIcon(doc.url)}
                              alt="file"
                              style={{ width: '20px', height: '20px', flexShrink: 0 }}
                            />
                            <span
                              className="font12 fw400 color111"
                              style={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                              title={doc.nm}
                            >
                              {doc.nm}
                            </span>
                          </a>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommentsPopup;

CommentsPopup.propTypes = {
  commentsData: PropTypes.array,
  commentsRef: PropTypes.object,
  myTicketsData: PropTypes.array,
  handleClosePopup: PropTypes.func,
};
